import { concantQuery } from '@/utils/concatQuery'
import api from './api'
import EventEmitter from '@/utils/EventEmitter'

export const SalesRevenueEventEmitter = new EventEmitter()

const wsEvents = {
  CAR_MANAGER_CAR_ENDED: 'CAR_MANAGER_CAR_ENDED'
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => SalesRevenueEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    SalesRevenueEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_CAR_MANAGER: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_CAR_MANAGER'))
  },
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => SalesRevenueEventEmitter.emit(eventName, args))
  })
}

/**
 * Get auctions.
 * @param {object} params - query params
 * @param {number} params.take - maximum number of elements
 * @param {number} params.skip - number of elements to skip
 * @param {string} params.search - search query
 * @returns
*/
const loadSalesRevenue = ({ take, skip, search, all }) => {
  const query = concantQuery({ take, skip, search, all })
  return api.get(`/statistical/sales${query}`)
}

export {
  loadSalesRevenue,
  bindWsEvents,
  wsActions,
  wsListeners,
  wsEvents
}
